<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/guizhouInspectGroupIndex">首页</el-menu-item>
        <el-menu-item index="/guizhouInspectGroup/currentDataTable?bridgeId=d9947c5e-0ba6-43ad-bd1b-e9d9bc50ee90">实时数据表</el-menu-item>
        <el-submenu :index="'/guizhouInspectGroup/dataHistory?bridgeId=d9947c5e-0ba6-43ad-bd1b-e9d9bc50ee90&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/guizhouInspectGroup/dataHistory?bridgeId=d9947c5e-0ba6-43ad-bd1b-e9d9bc50ee90&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/guizhouInspectGroup/dataHistory?bridgeId=d9947c5e-0ba6-43ad-bd1b-e9d9bc50ee90"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="GUIZHOU" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main guizhou-inspect-group">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
  <script>
export default {
  name: "guizhouInspectGroup",
  data() {
    return {
      bridgeId: "d9947c5e-0ba6-43ad-bd1b-e9d9bc50ee90",
      envInfo: {
        envId: "70177c47-36da-42a6-aa2e-9918f4794b5f",
        weather: "39555c1e-816f-486c-855a-db3b87ada2a8",
        humidity: "2da8dff3-7e5f-4bcd-9c12-08a83d048c60",
        temperature: "03435df4-2383-412a-8d47-7d82731484f5",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>